import axios from 'axios';

const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
const origin = typeof window !== 'undefined' ? window.location.origin : '';

// www.maccaron.in에서 접속 시 요청도 동일 origin을 따라가게 설정
const isWww = hostname.startsWith('www.');
const isComDomain = hostname.endsWith('.com');

// Product
const PRODUCT_SEARCH_BASE_URL = isWww
    ? `${origin}/search`
    : isComDomain
        ? process.env.COM_ELASTIC_SEARCH_URL
        : process.env.ELASTIC_SEARCH_URL;

// Brand
const BRAND_SEARCH_BASE_URL = isWww
    ? `${origin}/brand_search`
    : isComDomain
        ? process.env.COM_ELASTIC_SEARCH_BRAND_URL
        : process.env.ELASTIC_SEARCH_BRAND_URL;

// Tag
const TAG_SEARCH_BASE_URL = isWww
    ? `${origin}/tag_search`
    : isComDomain
        ? process.env.COM_ELASTIC_SEARCH_PRODUCT_TAG_URL
        : process.env.ELASTIC_SEARCH_PRODUCT_TAG_URL;

// Product
export const elasticSearchProductResult = async (searchValue: string) => {
  try {
    const response = await axios.post(`${PRODUCT_SEARCH_BASE_URL}/_search`, {
      from: 0,
      size: 10,
      query: {
        bool: {
          must: [
            {
              match: {
                title: searchValue,
              },
            },
            {
              term: {
                is_published: true,
              },
            },
          ],
        },
      },
      sort: [
        {
          _script: {
            type: 'number',
            script: {
              source: 'doc["popularity"].value * 0.0005 + _score',
            },
            order: 'desc',
          },
        },
        {
          _score: {
            order: 'desc',
          },
        },
      ],
    });

    return response?.data?.hits?.hits || [];
  } catch (error) {
    console.log('Error searching products:', error);
  }
};

// Brand
export const elasticSearchBrandResult = async (searchValue: string) => {
  try {
    const response = await axios.post(`${BRAND_SEARCH_BASE_URL}/_search`, {
      size: 3,
      query: {
        bool: {
          must: [
            {
              match: {
                name: {
                  query: searchValue,
                },
              },
            },
            {
              term: {
                is_published: true,
              },
            },
          ],
        },
      },
    });

    return response?.data?.hits?.hits || [];
  } catch (error) {
    console.log('Error searching brands:', error);
  }
};

// Tag
export const elasticSearchTagResult = async (searchValue: string) => {
  try {
    const response = await axios.post(`${TAG_SEARCH_BASE_URL}/_search`, {
      query: {
        bool: {
          must: [
            {
              match: {
                tag: searchValue,
              },
            },
            {
              match: {
                content_type: 'product_product',
              },
            },
          ],
        },
      },
      aggregations: {
        unique_tags: {
          terms: {
            field: 'tag_graphql_id',
            size: 10,
          },
          aggs: {
            first_tag: {
              top_hits: {
                size: 1,
                _source: {
                  includes: ['tag'],
                },
              },
            },
          },
        },
      },
    });

    return response?.data?.aggregations?.unique_tags?.buckets || [];
  } catch (error) {
    console.log('Error searching tags:', error);
  }
};

// Brand List
export const elasticSearchBrandListByBody = async (body) => {
  try {
    const response = await axios.post(`${BRAND_SEARCH_BASE_URL}/_search`, {
      ...body,
    });

    const sourceArray = response?.data?.hits.hits.map((hit) => hit._source);
    return sourceArray;
  } catch (error) {
    console.log('Error searching brand list:', error);
  }
};
